export const PHONE_DISPLAY = "328 787 3805";
export const PHONE_TEL = "+393287873805";
export const WHATSAPP_URL =
  "https://wa.me/393287873805?text=" +
  encodeURIComponent(
    "Buongiorno, vorrei richiedere un sopralluogo gratuito per la posa del parquet."
  );

export const POSE = [
  {
    id: "dritta",
    nome: "Posa a correre",
    prezzo: 23,
    note: "Posa del battiscopa inclusa nel prezzo",
    tagline: "Linee pulite, respiro agli spazi: l'eleganza senza tempo della posa dritta.",
  },
  {
    id: "spina_italiana",
    nome: "Spina italiana",
    prezzo: 28,
    note: "Incastri perpendicolari a 90°, disegno continuo",
    tagline: "Eleganza geometrica, carattere italiano.",
  },
  {
    id: "spina_francese",
    nome: "Spina francese / ungherese",
    prezzo: 32,
    note: "Tagli a 45°/30°, massima precisione",
    tagline: "Il disegno più ricercato, effetto sartoriale.",
  },
];

export const EXTRA_SERVIZI = [
  { id: "lamatura", nome: "Lamatura parquet", prezzo: 27, da: true },
  { id: "spc", nome: "Posa SPC", prezzo: 15, da: true },
  { id: "laminato", nome: "Posa laminato", prezzo: 15, da: true },
  { id: "pvc", nome: "Posa PVC", prezzo: 15, da: true },
];

export const STRIP_SERVIZI = [
  { label: "Lamatura", prezzo: 27 },
  { label: "Posa SPC", prezzo: 15 },
  { label: "Laminati", prezzo: 15 },
  { label: "PVC", prezzo: 15 },
];

export const INSTAGRAM_URL = "https://www.instagram.com/rus.srl/";
export const INSTAGRAM_HANDLE = "rus.srl";

export const POSE_IMG = {
  dritta: "/assets/lavori/federica/g1.jpg",
  spina_italiana: "/assets/lavori/antonio/c2.jpg",
  spina_francese: "/assets/lavori/nicola/m4.jpg",
  lamatura: "/assets/lavori/francesco/t1.jpg",
  spc: "/assets/lavori/sylvie/f1.jpg",
  laminato: "/assets/laminato-bg.jpg",
  pvc: "/assets/lavori/daniele/d3.jpg",
};

export const CONDIZIONI = [
  { id: "arredata", label: "Casa arredata / mobili presenti", extra: 0.08 },
  { id: "porte", label: "Porte da adattare", extra: 0.08 },
  { id: "dislivelli", label: "Dislivelli del sottofondo da correggere", extra: 0.12 },
];

export const IMAGES = {
  hero: "/assets/lavori/antonio/c1.jpg",
  manifesto: "/assets/lavori/lamatura/b3.jpg",
  gallery: [
    "https://images.pexels.com/photos/37341468/pexels-photo-37341468/free-photo-of-wooden-parquet-flooring-in-herringbone-pattern.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "https://images.pexels.com/photos/7258193/pexels-photo-7258193.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "https://images.pexels.com/photos/17806788/pexels-photo-17806788.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "https://images.pexels.com/photos/9819644/pexels-photo-9819644.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "https://images.pexels.com/photos/7587861/pexels-photo-7587861.jpeg?auto=compress&cs=tinysrgb&w=1200",
    "https://images.pexels.com/photos/15066939/pexels-photo-15066939/free-photo-of-pattern-on-a-hardwood-flooring.jpeg?auto=compress&cs=tinysrgb&w=1200",
  ],
};

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  }).format(n);

export const scrollToId = (id) => {
  const lenis = window.__lenis;
  if (lenis) lenis.scrollTo(`#${id}`, { offset: -70, duration: 1.4 });
  else document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
};
